export const environment = {
  production: false,
  envType: 'DEVELOPMENT',
  isFullOnline: true,
  caisseApiUrl: 'https://devgestion.quiditmiam.fr/api',
  title: 'Caisse Collective - Développement',
  buildDate: "2026-09-09T10:37:57",
  lastPipeline: "6504",
  version: "0.0.0",
  sentryDsn: '',
};
